import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import ImportDropzone from '../../../../../../components/FileImportDropzone';

const messages = defineMessages({
  import: {
    id: 'super_survey_import.file_field_label',
    defaultMessage: 'Import Surveys',
  },
});

/**
 * Render import form  for survey project
 * @param {*} props
 */
const SurveyProjectImport = ({ onUpload }) => {
  const { formatMessage } = useIntl();

  return (
    <Panel header={formatMessage(messages.import)}>
      <div className="p-grid">
        <div className="p-col-12">
          <a target="_blank" href="/import-templates/import-surveys.xlsx">
            <FormattedMessage id="res_import.download_hint" defaultMessage="Download Import Template file" />
          </a>
        </div>
        <div className="p-col-12">
          <ImportDropzone onUpload={onUpload} />
        </div>
      </div>
    </Panel>
  );
};

SurveyProjectImport.propTypes = {
  onUpload: PropTypes.func.isRequired,
};

export default SurveyProjectImport;
